import React, { useEffect, useState } from 'react';
import EfSpec from '@elem/ui/ef-spec';
import { getIsPadWidth } from '@elem/utils/devices';
import TeaserJp from '../teaserJp';
import TeaserNa from '../teaserNa';
import Banner from './comps/Banner';
import CardB1 from './comps/CardB1';
import CardB2 from './comps/CardB2';
import FooterTC from './comps/FooterTC';
import FullA from './comps/FullA';
import FullB from './comps/FullB';
import ListA from './comps/ListA';
import PowerSolutions from './comps/PowerSolutions';
import SignUp from './comps/SignUp';
import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useProductStore } from '../ProductProvider';
import { IPageStatus } from '../config/IPageStatus';

function TeaserEu() {
    const { locale } = getLocal();
    const { pageStatus } = useProductStore();
    const [specVisible, setSpecVisible] = useState(false);

    useEffect(() => {
        const isMobile = getIsPadWidth(); //是否是移动端
        setSpecVisible(!!isMobile);
    }, []);

    return (
        <div className={styles.teaser}>
            <Banner />
            <EfSpec />
            <PowerSolutions />
            <SignUp />
            {!specVisible && <EfSpec />}
            <FullA />
            <FullB />
            <ListA />
            <CardB1 />
            {/** 10.14 做次修改, uk 正式页不显示 CardB2 */}
            {/* {pageStatus === IPageStatus.statusB && locale === 'uk' && <CardB2 />} */}
            <FooterTC />
        </div>
    );
}

export default function Teaser() {
    const { locale } = getLocal();
    if (['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale)) {
        return <TeaserEu />;
    }
    if (locale === 'jp') {
        return <TeaserJp />;
    }
    return <TeaserNa />;
}
